import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Table,
  Input,
  Select,
  Form,
  Tooltip,
  Col,
  Spin,
  Radio,
  Row,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import { getRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { useNavigate } from "react-router-dom";
import PurchaseRequisitionSites from "./PurchaseRequisitionSites";
import PropTypes from "prop-types";
import { InfoCircleOutlined } from "@ant-design/icons";
const { Panel } = Collapse;

const PRPopUpDetails = ({ statePRDetails }) => {
  const [siteName, setSiteName] = useState([]);
  const navigate = useNavigate();
  const { Option } = Select;
  const [pincodeList, setPincodeList] = useState([]);
  // const [loading, setLoading] = useState(false);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoading2, setBtnLoading2] = useState(false);
  const [view, setView] = useState("");
  // const [loading, setLoading] = useState(false);
console.log("statePRDetails", statePRDetails);

  const { t } = useTranslation();
  const { id, prId } = useParams();
  const formRef = useRef();

  const [estimatedValueFromApi, setEstimatedValueFromApi] = useState([
    {
      id: "",
      value: "",
    },
  ]);
  const [totalAmountPr, setTotalAmountPr] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [stateWBS, setStateWBS] = useState([]);
  // Generate random items based on the template

  // const [siteWiseTotal, setSiteWiseTotal] = useState({
  //   siteName: "",
  //   total: "",
  // });

  const [siteWiseTotalAmount, setSiteWiseTotalAmount] = useState({
    siteName: "",
    total: "",
  });

  const [siteTotalQuantities, setSiteTotalQuantities] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [cityLength, setCityLength] = useState(1);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [apiLoading, setapiLoading] = useState(false);
  const [viewOption, setViewOption] = useState(false);
  const [prView, setPRView] = useState(null);

  const [overallTotal, setOverallTotal] = useState(0);
  // const [state, setState] = useState([])

  // useEffect(() => {
  //   document.addEventListener("contextmenu", (e) => {
  //     e.preventDefault();
  //   });
  // }, []);

  //   const getSubCategory = async () => {
  //     setapiLoading(true);
  //     // setLoading(true);

  //     try {
  //       // let apiResponse = await getRequest(
  //       //   `category-item-setting/1/get-pr-material-by-city/`
  //       // );
  //       let apiResponse = await getRequest(`purchase-requisition/${PRid}/`);

  //       console.log("apiResponse 114 ", apiResponse);

  //       if (apiResponse.data.success) {
  //         setState(apiResponse.data.data);
  //         setPRView(apiResponse?.data?.data?.pr_type);

  //         const prType = apiResponse.data.data.pr_type || "Material Wise";
  //         setView(prType);

  //         // if(apiResponse?.data?.data?.pr_type === "City Wise"){
  //         // setView(prType);
  //         formRef.current.setFieldsValue({
  //           pr_view: prType,
  //         });
  //         // }
  //         // else{
  //         // setView("Material Wise")
  //         // }
  //       }

  //       if (apiResponse.data.data) {
  //         const purchaseRequisitionDetails = apiResponse.data.data.map((item) => {

  //         });
  //         setState((prevState) => ({
  //           ...prevState,
  //           purchase_requisition_details: purchaseRequisitionDetails,
  //         }));
  //         // Filter out unique subcategories
  //         const uniqueSubCategories = Array.from(
  //           new Set(apiResponse.data.data.map((item) => item.sub_category))
  //         );

  //         // Set the state with unique subcategories
  //         setSubCategoryList(uniqueSubCategories);
  //         setSubCategoryData(apiResponse.data.data);
  //         setapiLoading(false);
  //         // setTimeout(() => setLoading(false), 1000);
  //       } else {
  //         ErrorNotificationMsg(t("error_in_company_adress_list"));
  //       }
  //       setapiLoading(false);
  //       // setTimeout(() => setLoading(false), 1000);
  //     } catch (error) {
  //       setapiLoading(false);
  //       // setTimeout(() => setLoading(false), 1000);
  //     }
  //   };
  console.log("updateTableData(statePRDetails)", statePRDetails);
  useEffect(() => {
    // getSubCategory();
    getCurrency();
    getUnitOfMeasurement();
    // if (siteName.length === 0) {
    //   getSiteName();

    // }
  }, [id, prId]);

  let updateTableData = [];

  updateTableData = (state) => {
    // setapiLoading(true);
    // setLoading(true);
    const tableData = [];
    const length = statePRDetails?.length;
    // const length = 2;

    setCityLength(length);
    let totalCityOfAllSite = 0;
    statePRDetails?.forEach((city, cityIndex) => {
      const cityRowSpan = city.site_wise_pr.length;
      let cityTotalQuantity = 0;
      let cityTotalQuantityByKg = 0;
      let cityTotal = 0;
      // cityTotal += cityTotalQuantity;
      let cityAmount = 0;

      city.site_wise_pr.forEach((site, siteIndex) => {
        let siteTotalQuantity = 0;
        let siteTotalQuantityForKG = 0;
        let siteMaterialTotal = 0;
        site.site_total_quantity += siteTotalQuantity;

        let siteAmount = 0;

        console.log("pr_material_details", site.pr_material_details);
        site.pr_material_details?.forEach((material) => {
          console.log("material890 ", material);

          siteTotalQuantity += material.pr_material_type_quantity;
          siteMaterialTotal += material.pr_material_type_quantity * 105;
          siteTotalQuantityForKG += material.pr_material_type_quantity_by_kg;
          // material.estimated_material_unit_price;
          if (material.pr_material_type_uom_name === "Cubic Meter") {
            siteAmount +=
              material.pr_material_type_quantity *
              material.estimated_material_unit_price;
          } else {
            siteAmount +=
              material.pr_material_type_quantity_by_kg *
              material.estimated_material_unit_price;
          }
        });
        site.site_total_quantity = siteTotalQuantity;
        console.log("siteTotalQuantityForKG", siteTotalQuantityForKG);
        setSiteTotalQuantities((prevQuantities) => [
          ...prevQuantities,
          siteTotalQuantity,
        ]);

        cityTotalQuantity += siteTotalQuantity;
        cityTotal += siteMaterialTotal;
        cityTotalQuantityByKg += siteTotalQuantityForKG;
        cityAmount += siteAmount;
        totalCityOfAllSite += siteAmount;

        tableData.push({
          key: `${cityIndex}-${siteIndex}`,
          // srNo: siteIndex === 0 ? cityIndex + 1 : null,
          srNo:
            length > 1
              ? siteIndex === 0
                ? cityIndex + 1
                : null
              : siteIndex + 1,
          cityName: siteIndex === 0 ? city.city_name : null,
          cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
          siteName: site.site_name,
          siteLocations: site.pr_material_details?.map((material, matIndex) => {
            console.log("material560 ", material);

            return {
              availableBudget: material.available_budget || 0,
              estimatedPRValue: material.estimated_material_unit_price || 0,
              remark: material.remark,
              materialName: material.pr_material_type_name,
              quantity: material.pr_material_type_quantity,
              quantityForKG: material.pr_material_type_quantity_by_kg,
              // siteTotalQuantity: siteTotalQuantity,
              uom: material.pr_material_type_uom_id,
              uom_name: material.pr_material_type_uom_name,
              subCategory: material.pr_material_type_sub_category,
              siteIndex,
              matIndex,
              cityId: city.city_name,
              siteId: site.pr_site_id,
              estimatedPrice: material.estimated_material_unit_price,

              amount:
                material.pr_material_type_uom_name === "Cubic Meter"
                  ? material.pr_material_type_quantity *
                    material.estimated_material_unit_price
                  : material.pr_material_type_quantity_by_kg *
                    material.estimated_material_unit_price,
            };
          }),
          totalAmount: (
            <Input
              disabled
              // value={`\u20B9 ${5658 || 0}`}
              className="site-subtotal"
              // readOnly
            />
          ),
        });

        // Add site-sub-total row
        tableData.push({
          key: `${cityIndex}-${siteIndex}-SiteSubTotal`,
          siteName: "Site Sub-Total",
          siteLocations: [
            {
              totalQuantity: siteMaterialTotal,
              materialName: "",
              quantity: siteTotalQuantity,
              quantityForKG: siteTotalQuantityForKG,
              subCategory: "",
              siteIndex,
              matIndex: 0,
              cityId: city.city_id,
              siteId: site.site_id,
              amount: siteAmount,
            },
          ],
          totalAmount: (
            <Input
              disabled
              value={`\u20B9 ${siteTotalQuantity || 0}`}
              className="site-subtotal"
              // readOnly
            />
          ),
          siteTotalQuantity: (
            <Input
              disabled
              value={siteTotalQuantity || 0}
              className="site-total-quantity"
              readOnly
            />
          ),
        });

        // Add city total row at the end of the city's site list
        if (length > 1) {
          if (siteIndex === city.site_wise_pr.length - 1) {
            tableData.push({
              key: `${cityIndex}-${siteIndex}-CityTotal`,
              siteName: "City Total",
              siteLocations: [
                {
                  materialName: "",
                  cityTotal: cityTotal,
                  quantity: cityTotalQuantity,
                  quantityForKG: cityTotalQuantityByKg,
                  subCategory: "",
                  siteIndex,
                  matIndex: 0,
                  cityId: city.city_id,
                  siteId: site.site_id,
                  amount: cityAmount,
                },
              ],
              totalAmount: (
                <Input
                  disabled
                  value={`\u20B9 ${cityTotalQuantity || 0}`}
                  className="subtotal"
                  readOnly
                />
              ),
              cityTotalQuantity: (
                <Input
                  disabled
                  value={city.city_total_quantity || 0}
                  className="city-total-quantity"
                  readOnly
                />
              ),
            });
          }
        }
      });

      city.city_total_quantity = cityTotal;
    });
    let totalAmount;
    let totalQuantity;
    tableData.push({
      key: `Total`,
      siteName: `Est. Total`,
      siteName1: "Total",
      siteLocations: [
        {
          materialName: "",
          cityTotal: "",
          quantity: "",
          totalCityOverallSite: totalCityOfAllSite,
          cityQuantityForKG: "",
          cityTotalAmountForKG: "",
          subCategory: "",
          siteIndex: 0,
          matIndex: 0,
          // cityId: city.city_id,
          // siteId: site.site_id,
        },
      ],
      totalAmount: <Input disabled value="₹ 0" className="subtotal" readOnly />,
      totalQuantity: (
        <Input disabled value="0" className="city-total-quantity" readOnly />
      ),
    });
    setTableData(tableData);
    // setapiLoading(false);
    // setTimeout(() => setLoading(false), 1000);
  };

  //   }

  useEffect(() => {
    // setapiLoading(true);
    // setLoading(true);
    console.log("statePRDetails", statePRDetails);
    updateTableData(statePRDetails);
    // setapiLoading(false);
    // setTimeout(() => setLoading(false), 1000);
  }, [statePRDetails]);

  const getUnitOfMeasurement = async (data) => {
    // setapiLoading(true);
    // setLoading(true);
    await getRequest("get-category-by-uom/?category_tree", data).then(
      (response) => {
        setPincodeList(response.data.results.data);
      }
    );
  };

  console.log("tableData", tableData);

  //   const getSiteName = async () => {
  //     //setLoading(true);

  //     try {
  //       let apiResponse = await getRequest(
  //         `delivery-address/${CompanyID}/address-by-company/`
  //       );
  //       if (apiResponse.data.data) {
  //         setSiteName(apiResponse.data.data);
  //         const updatedState = { ...state };
  //         updatedState.purchase_requisition_details.forEach((detail) => {
  //           detail.site_wise.forEach((site, index) => {
  //             site.site_name = apiResponse.data.data[index]
  //               ? apiResponse.data.data[index].site.id
  //               : null;
  //           });
  //         });

  //         setState(updatedState);
  //       } else {
  //         ErrorNotificationMsg(t("error_in_company_adress_list"));
  //       }
  //       //setLoading(false);
  //     } catch (error) {
  //       //setLoading(false);
  //     }
  //   };

  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };

  //   const wbsBudget = [
  //     {
  //       title: "Sr.",
  //       dataIndex: "srNo",
  //       fixed: "left",
  //       width: 100,
  //     },
  //     {
  //       title: "Site",
  //       dataIndex: "siteName",
  //       fixed: "left",
  //       width: 150,
  //       render: (text) => <div className="lblvalue">{text}</div>,
  //     },
  //     {
  //       title: "Available Budget",
  //       dataIndex: "siteLocations",
  //       width: 150,
  //       render: (siteLocations, record) => {
  //         if (record.siteName !== "City Total" && record.siteName !== "Total") {
  //           return (
  //             <div
  //               style={{
  //                 display: "flex",
  //                 flexDirection: "column",
  //                 gap: "10px",
  //                 marginRight: "20px",
  //               }}
  //             >
  //               {/* {siteLocations.map((site, index) => ( */}
  //               <div key={1} className="lblvalue">
  //                 <Input
  //                   addonBefore={currencySymbol}
  //                   type="number"
  //                   min={0}
  //                   style={{ width: "100%" }}
  //                   readOnly
  //                   value={1000000}
  //                 />
  //               </div>
  //               {/* ))} */}
  //             </div>
  //           );
  //         }
  //         return null;
  //       },
  //     },
  //     {
  //       title: "Estimated PR Value",
  //       dataIndex: "siteLocations",
  //       width: 150,
  //       render: (siteLocations, record) => {
  //         if (record.siteName === "City Total" || record.siteName === "Total") {
  //           return (
  //             <div
  //               style={{
  //                 display: "flex",
  //                 flexDirection: "column",
  //                 gap: "10px",
  //                 marginRight: "20px",
  //               }}
  //             >
  //               <div className="lblvalue">
  //                 <Input
  //                   addonBefore={currencySymbol}
  //                   type="number"
  //                   min={0}
  //                   style={{ width: "100%" }}
  //                   value={siteLocations[0].cityTotal}
  //                   readOnly
  //                 />
  //               </div>
  //             </div>
  //           );
  //         } else {
  //           return (
  //             <div
  //               style={{
  //                 display: "flex",
  //                 flexDirection: "column",
  //                 gap: "10px",
  //                 marginRight: "20px",
  //               }}
  //             >
  //               {/* {siteLocations.map((site, index) => ( */}
  //               <div key={1} className="lblvalue">
  //                 <Input
  //                   addonBefore={currencySymbol}
  //                   type="number"
  //                   min={0}
  //                   style={{ width: "100%" }}
  //                   value={siteLocations[0].estimatedPRValue}
  //                   readOnly
  //                 />
  //               </div>
  //               {/* ))} */}
  //             </div>
  //           );
  //         }
  //       },
  //     },
  //   ];

  //   if (cityLength > 1) {
  //     wbsBudget.splice(1, 0, {
  //       title: "City",
  //       dataIndex: "cityName",
  //       key: "cityName",
  //       width: 150,
  //       render: (text) => <div className="lblvalue">{text}</div>,
  //     });
  //   }

  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      fixed: "left",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      fixed: "left",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return <div className="subtotal">{"Sub total"}</div>;
        } else if (record.siteName === "City Total") {
          return <div className="citytotal">{"City total"}</div>;
        } else if (record.siteName1 === "Total") {
          return (
            <div className="totalCityOverallSite1">
              <Tooltip
                color={colors}
                placement="left"
                title={<span style={{ color: "#fff" }}>Estimated Amount</span>}
              >
                {record.siteName}{" "}
                <InfoCircleOutlined
                  style={{ color: "#094E8F", marginLeft: "3px" }}
                />
              </Tooltip>
            </div>
          );
        } else {
          return <>{record.siteName}</>;
        }
      },
    },
    {
      title: "Item",
      dataIndex: "siteLocations",
      fixed: "left",
      width: 190,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.materialName}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: "Qty.",
      dataIndex: "siteLocations",
      fixed: "right",
      align: "center",
      width: 80,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return <></>;
        } else if (record.siteName === "City Total") {
          return <></>;
        } else if (record.siteName1 === "Total") {
          return <></>;
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  // marginRight: "20px",
                  marginLeft: "5px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div key={index} className="lblvalue">
                    {site.quantity}
                  </div>
                ))}
              </div>
            </>
          );
        }
      },
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Preferred Unit of measurement means Your company buys material
              generally in this unit of measurement
            </span>
          }
        >
          Preferred UoM.
        </Tooltip>
      ),
      width: 130,
      dataIndex: "siteLocations",
      align: "center",
      render: (siteLocations, record) => {
        console.log("siteLocationsTotal", siteLocations);
        const defaultOption = pincodeList.find(
          (option) => option.unit_of_measurement === "MT"
        );
        const defaultValue = defaultOption ? defaultOption.id : 1;
        if (
          record.siteName === "City Total" ||
          record.siteName === "Site Sub-Total" ||
          record.siteName === "Total"
        ) {
          return "";
        }
        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {siteLocations.map((site, index) => {
                console.log("sitedd5d", site);
                if (site.uom_name === "Cubic Meter") {
                  return (
                    <div
                      key={index}
                      className="lblvalue"
                      style={{ marginLeft: "5px" }}
                    >
                      Cu. Mtr.
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={index}
                      className="lblvalue"
                      style={{ marginLeft: "5px" }}
                    >
                      {site.uom_name}
                    </div>
                  );
                }
              })}
            </div>
          </>
        );
      },
    },
    {
      title: "Qty. In Kg",
      dataIndex: "siteLocations",
      width: 130,
      // className: 'column-right',
      align: "right",
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          // return (
          //   <>
          //   </>
          // );
        } else if (record.siteName === "City Total") {
          // return (
          //   <>
          //   </>
          // );
        } else if (record.siteName === "Total") {
          //   return <></>;
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                  //marginLeft: "5px"
                  marginRight: "5px",
                }}
              >
                {siteLocations.map((site, index) => {
                  console.log("site101 ", site);
                  return (
                    <div key={index} className="">
                      {site?.quantityForKG == 0 ? '-': site?.quantityForKG?.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                })}
                    </div>
                  );
                })}
              </div>
            </>
          );
        }
      },
    },
    {
      title: (
        <Tooltip
          title="Reference price of estimated unit rate comes from material master data"
          color="#094E8F"
          placement="top"
        >
          <span>Est. Unit rate</span>
        </Tooltip>
      ),
      dataIndex: "siteLocations",
      width: 140,
      align: "right",
      render: (siteLocations, record) => {
        console.log("siteLocations555", siteLocations, record);

        if (
          record.siteName !== "Site Sub-Total" &&
          record.siteName !== "Est. Total" &&
          record.siteName !== "City Total"
        ) {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div
                    key={index}
                    className="lblvalue"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹ {site.estimatedPrice}{" "}
                    {site.subCategory === "RMC" ? "/ Cu. Mtr." : "/ Kg"}
                  </div>
                ))}
              </div>
            </>
          );
        }
      },
    },
    {
      title: "Est. Amount",
      dataIndex: "amount",
      key: "amount",
      width: 150,
      align: "right",

      render: (text, record) => {
        if (record.siteName === "Site Sub-Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                className="subtotal"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                  // marginRight: "20px",
                  //marginLeft: "5px"
                }}
              >
                {record.siteLocations.map((site, index) => {
                  console.log("site698 ", site, "record", record);
                  return (
                    <div key={index} className="">
                      ₹ {site.amount ? site.amount?.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                }) : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        } else if (record.siteName === "City Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                className="citytotal"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                  // marginRight: "20px",
                  //marginLeft: "5px"
                }}
              >
                {record.siteLocations.map((site, index) => {
                  console.log("site698 ", site, "record", record);
                  return (
                    <div key={index} className="">
                      ₹ {site.amount ? site.amount?.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                }) : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        } else if (record.siteName1 === "Total") {
          //   console.log("site4ff", site);
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            {
              console.log(
                "Total Hub",
                record.siteLocations[0]?.totalCityOverallSite
              );
              return (
                <div className="totalCityOverallSite1">
                  ₹{" "}
                  {record.siteLocations[0]?.totalCityOverallSite
                    ? record.siteLocations[0]?.totalCityOverallSite?.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                })
                    : 0}
                </div>
              );
            }
          }
        } else {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "flex-end",
                  marginRight: "5px",
                }}
              >
                {record.siteLocations.map((site, index) => {
                  console.log("site698 ", site, "record", record);
                  return (
                    <div key={index} className="lblvalue">
                      ₹ {site.amount ? site.amount?.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                }) : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Remarks",
      dataIndex: "siteLocations",
      // width: 150,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.remark}
              </div>
            ))}
          </div>
        </>
      ),
    },
  ];

  if (cityLength > 1) {
    columns.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 120,
      render: (text, record, index) => {
        if (index === 0 || record.cityName !== tableData[index - 1].cityName) {
          return <div className="lblvalue">{text}</div>;
        } else {
          return <div className="lblvalue" />;
        }
      },
    });
  }

  const theadPR = <Table columns={columns} />;

  const colors = ["#094E8F"];
  return (
    <>
      {/* <Spin spinning={apiLoading}> */}
      {
        <>
          {/* <Collapse key={"0"} defaultActiveKey={["0"]} className="scroll4">
            <Panel header={theadPR}> */}
              <Table
                header={theadPR}
                loading={apiLoading}
                columns={columns}
                dataSource={tableData}
                pagination={false}
                className="modal-table"
              />
            {/* </Panel>
          </Collapse> */}
        </>
      }
      {/* </Spin> */}
    </>
  );
};

PRPopUpDetails.propTypes = {
  statePRDetails: PropTypes.func,
};

export default PRPopUpDetails;
